import PropTypes from 'prop-types';
import IconSvg from 'Components/IconSvg';

const Checkbox = ({ defaultChecked, onChange, text, value }) => {
  return (
    <label className="checkbox">
      <input
        defaultChecked={defaultChecked}
        type="checkbox"
        value={value}
        onChange={onChange}
      />
      <div className="checkbox__indicator">
        <div className="checkbox__icon">
          <IconSvg type="checkmark" />
        </div>
      </div>
      <span className="checkbox__text">{text}</span>
    </label>
  );
};

Checkbox.propTypes = {
  defaultChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default Checkbox;
